/**
 *
 * @param {{children:import("react").ReactNode, isLoaded:boolean,className?:string}} param0
 * @returns
 */
export default function Skeleton({ children, isLoaded, className }) {
  return (
    <>
      {isLoaded ? (
        children
      ) : (
        <div
          className={`animate-pulse bg-segments-accent-color-1 opacity-30 rounded-xl ${className}`}
        >
          <div className="invisible">{children}</div>
        </div>
      )}
    </>
  );
}
